const constants = require('@/util/constants')
require('./config')

/**
 * 分页获取工作组
 * @param {*} accessToken token
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function getWorkGroups (page, size, successcb, failedcb) {
  axios.get('/api/workgroup/get', {
    params: {
      'page': page,
      'size': size,
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 获取全部工作组
 * @param {*} accessToken token
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function getAllWorkGroups (successcb, failedcb) {
  axios.get('/api/workgroup/all', {
    params: {
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 搜索工作组
 * @param {*} accessToken token
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function filterWorkGroups (page, size, nickname, successcb, failedcb) {
  axios.get('/api/workgroup/filter', {
    params: {
      'page': page,
      'size': size,
      'nickname': nickname,
      'client': constants.HTTP_CLIENT
    }
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 创建工作组
 * @param {*} name 昵称
 * @param {*} defaultRobot 是否开启默认机器人
 * @param {*} offlineRobot 是否开启离线机器人
 * @param {*} forceRate 是否强制评价
 * @param {*} routeType 路由类型
 * @param {*} welcomeTip 初始欢迎语
 * @param {*} acceptTip 接入欢迎语
 * @param {*} offlineTip 离线提示语
 * @param {*} workTimes 工作时段，数组
 * @param {*} users 工作组成员
 * @param {*} onDutyWorkGroupWid 值班工作组wid
 * @param {*} accessToken token
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function createWorkgroup (nickname, avatar, defaultRobot, offlineRobot, forceRate,
  routeType, welcomeTip, acceptTip, offlineTip,
  workTimes, users, onDutyWorkGroupWid, admin, successcb, failedcb) {
//
  axios.post('/api/workgroup/create', {
    nickname,
    avatar,
    defaultRobot,
    offlineRobot,
    forceRate,
    routeType,
    welcomeTip,
    acceptTip,
    offlineTip,
    workTimes,
    users,
    onDutyWorkGroupWid,
    admin
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 更新工作组
 * @param {*} name 昵称
 * @param {*} defaultRobot 是否开启默认机器人
 * @param {*} offlineRobot 是否开启离线机器人
 * @param {*} forceRate 是否强制评价
 * @param {*} routeType 路由类型
 * @param {*} welcomeTip 初始欢迎语
 * @param {*} acceptTip 接入欢迎语
 * @param {*} offlineTip 离线提示语
 * @param {*} workTimes 工作时段，数组
 * @param {*} users 工作组成员
 * @param {*} accessToken token
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function updateWorkgroup (id, nickname, avatar, defaultRobot, offlineRobot, forceRate,
  routeType, welcomeTip, acceptTip, offlineTip,
  workTimes, users, onDutyWorkGroupWid, admin, successcb, failedcb) {
//
  axios.post('/api/workgroup/update', {
    id,
    nickname,
    avatar,
    defaultRobot,
    offlineRobot,
    forceRate,
    routeType,
    welcomeTip,
    acceptTip,
    offlineTip,
    workTimes,
    users,
    onDutyWorkGroupWid,
    admin
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}

/**
 * 删除工作组
 * @param {*} id id
 * @param {*} accessToken token
 * @param {*} successcb 成功回调
 * @param {*} failedcb 失败回调
 */
export function deleteWorkgroup (id, successcb, failedcb) {
  //
  axios.post('/api/workgroup/delete', {
    id
  }).then(response => {
    successcb(response.data)
  }).catch(error => {
    failedcb(error)
  })
}
